import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const GrabDotsIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <circle cx="3.0625" cy="2.25" r="2.25" fill={props.color}/>
      <circle cx="3.0625" cy="9" r="2.25" fill={props.color}/>
      <circle cx="3.0625" cy="15.75" r="2.25" fill={props.color}/>
      <circle cx="10.9375" cy="2.25" r="2.25" fill={props.color}/>
      <circle cx="10.9375" cy="9" r="2.25" fill={props.color}/>
      <circle cx="10.9375" cy="15.75" r="2.25" fill={props.color}/>
    </SvgCommon>
  );
};
